import { Action, createAction, handleActions } from "redux-actions";

export interface AuthenticatedViewState {
  tokenPermissions: string[];
  canCreateEndoso?: boolean;
  canApplyEndoso: boolean;
  canUploadImpresos: boolean;
  roles: string[];
  isAdminUser: boolean;
  displayMercadoAbiertoOnly?: boolean;
  canRenovarPolizas: boolean;
  canAnularPolizas: boolean;
}

const selectTokenPermissions = createAction(
  "SELECT_PERMISOS_TOKEN",
  (tokenPermissions: string[]) => ({
    tokenPermissions,
  })
);

const selectRoles = createAction("SELECT_ROLES", (roles: string[]) => ({
  roles,
}));

const authenticatedViewInitialState: AuthenticatedViewState = {
  tokenPermissions: [],
  canApplyEndoso: false,
  canUploadImpresos: false,
  roles: [],
  isAdminUser: false,
  canRenovarPolizas: false,
  canAnularPolizas: false,
};

const authenticatedViewReducer = handleActions<AuthenticatedViewState, any>(
  {
    [selectTokenPermissions.toString()]: (
      state,
      action: Action<{ tokenPermissions: string[] }>
    ) => {
      return {
        ...state,
        tokenPermissions: action.payload.tokenPermissions,
        canCreateEndoso: action.payload.tokenPermissions.some(
          (perm) => perm === "polizas:solicitarEndoso"
        ),
        canApplyEndoso: action.payload.tokenPermissions.some(
          (perm) => perm === "polizas:aplicarEndoso"
        ),
        canUploadImpresos: action.payload.tokenPermissions.some(
          (perm) => perm === "polizas:readAll"
        ),
        canAnularPolizas: action.payload.tokenPermissions.some(
          (perm) => perm === "polizas:anular"
        ),
      };
    },
    [selectRoles.toString()]: (state, action: Action<{ roles: string[] }>) => {
      return {
        ...state,
        roles: action.payload.roles,
        isAdminUser: action.payload.roles.some((role) => role === "admin"),
        displayMercadoAbiertoOnly: action.payload.roles.some(
          (role) => role === "oficina"
        ),
        canRenovarPolizas:
          action.payload.roles.some((role) => role === "admin") ||
          action.payload.roles.some((role) => role === "mesabackoffice"),
      };
    },
  },
  authenticatedViewInitialState
);

export { authenticatedViewReducer };
export { selectTokenPermissions, selectRoles };
